export const filterChartDatasets = (chartData, selectedProducts = []) => {
	if (!chartData) {
		return chartData;
	}

	const selectedNames = selectedProducts.map((product) => product.label);

	return {
		...chartData,
		datasets: (chartData.datasets || []).filter((dataset) =>
			selectedNames.includes(dataset.label),
		),
	};
};
